module.exports = __webpack_public_path__ + "static/teaching_01-db0aaa5ea58bb16a12f837f6e0a417f5.jpg";